export var WarrantyTypes;
(function (WarrantyTypes) {
    WarrantyTypes["Extended"] = "Extended";
    WarrantyTypes["Flexible"] = "Flexible";
    WarrantyTypes["Standard"] = "Standard";
    WarrantyTypes["Recommended"] = "Recommended";
    WarrantyTypes["Comprehensive"] = "Comprehensive";
    WarrantyTypes["Global"] = "Global";
})(WarrantyTypes || (WarrantyTypes = {}));
export var WarrantyOptionTypes;
(function (WarrantyOptionTypes) {
    WarrantyOptionTypes["Extended"] = "Extended";
    WarrantyOptionTypes["Flexible"] = "Flexible";
    WarrantyOptionTypes["Recommended"] = "Recommended";
    WarrantyOptionTypes["None"] = "None";
})(WarrantyOptionTypes || (WarrantyOptionTypes = {}));
export var CardGridType;
(function (CardGridType) {
    CardGridType["ModelCardGrid"] = "ModelCardGrid";
    CardGridType["TrimCardGrid"] = "TrimCardGrid";
})(CardGridType || (CardGridType = {}));
export var OfferTypes;
(function (OfferTypes) {
    OfferTypes["Loyalty"] = "Loyalty";
    OfferTypes["StackableRebate"] = "StackableRebate";
    OfferTypes["NonStackableRebate"] = "NonStackableRebate";
    OfferTypes["AdditionalSavings"] = "AdditionalSavings";
    OfferTypes["ProvincialGovernmentIncentive"] = "ProvincialGovIncentive";
    OfferTypes["FederalGovernmentIncentive"] = "FederalGovIncentive";
})(OfferTypes || (OfferTypes = {}));
export var LinkType;
(function (LinkType) {
    LinkType["INTERNAL"] = "internal";
    LinkType["EXTERNAL"] = "external";
})(LinkType || (LinkType = {}));
